<div class="list-header">
  <h2 class="list-header__content">
      <ng-content></ng-content>
  </h2>
</div>